import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  {
    errorTextContainer: {
      alignItems: "center",
      display: "flex",
      gap: "4px",
      margin: "12px 0 8px",
      color: "#EC5D77"
    },
    infoTextContainer: {
      alignItems: "center",
      display: "flex",
      gap: "4px",
      margin: "12px 0 16px",
      color: "#0030FF",
      backgroundColor: "#F4F8FF",
      borderRadius: 6,
      borderLeft: "6px solid #0030FF"
    },
    redirectTextContainer: {
      textAlign: "end",
      marginTop: 12
    },
    apiErrorContainer: {
      alignItems: "center",
      justifyContent: "space-between",
      display: "flex",
      gap: "4px",
      margin: "12px 0 8px",
      color: "#EC5D77"
    },
    messageWithButtonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: 12,
      "& > button": {
        "& > span": {
          color: "#FFF"
        },
        backgroundColor: "#1848FE"
      }
    }
  },
  { name: "InfoMessageComponent" }
);

export default useStyles;
